export default __webpack_public_path__ + "static/media/doubleeagle4.914e9754.jpg";